<template>
  <div :class="style.wrapper">
    <h3 :class="style.basicTitle">残り予算</h3>
    <div :class="variableClass">
      <span :class="style.bigNumber"
        >{{ remainingBudget | budgetFormatWithoutUnit }}
      </span>
      <span :class="style.bigNumber">
        / {{ budget | budgetFormatWithoutUnit }}</span
      >
      <span :class="style.unit">円</span>
    </div>
  </div>
</template>

<script>
import { cx } from 'emotion'
import {
  baseStyle,
  remainingBudgetStyle,
} from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/reminderStyles'
import { budgetFormatWithoutUnit } from '@/middlewares/numberFormat'

export default {
  name: 'RemainingBudget',
  props: {
    data: Object,
  },
  computed: {
    remainingBudget() {
      if (!this.data) return null
      if (this.data.remainingBudget < 0) {
        return 0
      }
      return this.data.remainingBudget
    },
    budget() {
      if (!this.data) return null
      return this.data.ioLifetimeBudget
    },
    variableClass() {
      return cx(baseStyle.variable, remainingBudgetStyle(this.data))
    },
    style() {
      return baseStyle
    },
  },
  filters: {
    budgetFormatWithoutUnit,
  },
}
</script>

<style></style>
